const resources = {
    shopThisPost: 'Shop This Post'
};

module.exports = function getResource(label) {
    return resources[label];
};
